import LayoutSetMyPreferences from 'components/ui/layout-set/persons/layout-set-my-preferences';

import PageMyPreferencesLayout from 'components/pages/professional/settings/my-preferences/shared/page-my-preferences-layout';
import PageMyPreferencesPersonal from 'components/pages/professional/settings/my-preferences/personal/page-my-preferences-personal';

import PageMyPreferencesProfilePicture from 'components/pages/professional/settings/my-preferences/profile-picture/page-my-preferences-profile-picture';

import PageMyPreferencesChangeEmail from 'components/pages/professional/settings/my-preferences/change-email/page-my-preferences-change-email';
import PageVerifyEmail from 'components/pages/professional/settings/my-preferences/change-email/page-verify-email';

import PageMyPreferencesChangePassword from 'components/pages/professional/settings/my-preferences/change-password/page-my-preferences-change-password';

import PageMyPreferencesExternalLinks from 'components/pages/professional/settings/my-preferences/external-links/page-my-preferences-external-links';

import PageMyPreferencesProfessionalBiography from 'components/pages/professional/settings/my-preferences/professional-biography/page-my-preferences-professional-biography';
import PageProfessionalExperienceCRED from 'components/pages/professional/settings/my-preferences/professional-biography/page-professional-experience-cred';
import PagePersonalEducationCRED from 'components/pages/professional/settings/my-preferences/professional-biography/page-personal-education-cred';
import PagePersonalInterestsCRED from 'components/pages/professional/settings/my-preferences/professional-biography/page-personal-interests-cred';

import PageMyPreferencesChangeStatus from 'components/pages/professional/settings/my-preferences/status/page-my-preferences-change-status';
import PageMyPreferencesPersonalRoles from 'components/pages/professional/settings/my-preferences/roles/page-my-preferences-personal-roles';

export default [
  {
    path: '/professional/settings/my-preferences',
    component: LayoutSetMyPreferences,
    meta: { auth: true },
    name: 'my-preferences',
    redirect: { name: 'my-preferences-personal' },
    props: {
      meta: {
        navigation: {
          status: 'my-preferences-settings-status',
        },
      },
    },
    children: [
      {
        path: 'profile',
        component: PageMyPreferencesLayout,
        props: true,
        meta: { auth: true },
        children: [
          {
            path: 'personal',
            name: 'my-preferences-personal',
            component: PageMyPreferencesPersonal,
            props: {
              meta: {
                title: 'label.personal',
                section: 'label.my_preferences',
              },
            },
          },
          {
            path: 'profile-picture',
            name: 'my-preferences-profile-picture',
            component: PageMyPreferencesProfilePicture,
            props: {
              meta: {
                title: 'label.profile_picture',
                section: 'label.my_preferences',
              },
            },
          },

          {
            path: 'external-links',
            name: 'my-preferences-external-links',
            component: PageMyPreferencesExternalLinks,
            props: {
              meta: {
                title: 'label.external_links',
                section: 'label.my_preferences',
              },
            },
          },
          {
            path: 'professional-biography',
            name: 'my-preferences-professional-biography',
            component: PageMyPreferencesProfessionalBiography,
            props: {
              meta: {
                title: 'label.professional_biography',
                section: 'label.my_preferences',
                navigation: {
                  cancel: 'my-preferences-professional-biography',
                  editExperience: 'my-preferences-professional-biography-edit-experience',
                  editEducation: 'my-preferences-professional-biography-edit-education',
                  editInterests: 'my-preferences-professional-biography-set-interests',
                },
              },
            },
            children: [
              {
                path: 'add-experience',
                name: 'my-preferences-professional-biography-add-experience',
                component: PageProfessionalExperienceCRED,
                props: {
                  meta: {
                    title: 'label.professional_experience',
                    section: 'label.my_preferences',
                    navigation: {
                      cancel: 'my-preferences-professional-biography',
                    },
                  },
                },
              },
              {
                path: 'edit-experience/:id',
                name: 'my-preferences-professional-biography-edit-experience',
                component: PageProfessionalExperienceCRED,
                props: route => ({
                  id: route.params.id,
                  meta: {
                    title: 'label.professional_experience',
                    section: 'label.my_preferences',
                    navigation: {
                      cancel: 'my-preferences-professional-biography',
                    },
                  },
                }),
              },
              {
                path: 'add-education',
                name: 'my-preferences-professional-biography-add-education',
                component: PagePersonalEducationCRED,
                props: {
                  meta: {
                    title: 'label.education',
                    section: 'label.my_preferences',
                    navigation: {
                      cancel: 'my-preferences-professional-biography',
                    },
                  },
                },
              },
              {
                path: 'edit-education/:id',
                name: 'my-preferences-professional-biography-edit-education',
                component: PagePersonalEducationCRED,
                props: route => ({
                  id: route.params.id,
                  meta: {
                    title: 'label.education',
                    section: 'label.my_preferences',
                    navigation: {
                      cancel: 'my-preferences-professional-biography',
                    },
                  },
                }),
              },
              {
                path: 'set-interests',
                name: 'my-preferences-professional-biography-set-interests',
                component: PagePersonalInterestsCRED,
                props: {
                  meta: {
                    title: 'label.set_interests',
                    section: 'label.my_preferences',
                    navigation: {
                      cancel: 'my-preferences-professional-biography',
                    },
                  },
                },
              },
            ],
          },
        ],
      },
      {
        path: 'settings',
        component: PageMyPreferencesLayout,
        props: true,
        meta: { auth: true },
        children: [
          {
            path: 'change-password',
            name: 'my-preferences-change-password',
            component: PageMyPreferencesChangePassword,
            props: {
              meta: {
                title: 'label.change_password',
                section: 'label.my_preferences',
              },
            },
          },
          {
            path: 'personal-roles',
            name: 'my-preferences-personal-roles',
            component: PageMyPreferencesPersonalRoles,
            props: {
              meta: {
                title: 'label.personal_roles',
                section: 'label.my_preferences',
              },
            },
          },
          {
            path: 'change-email',
            name: 'my-preferences-change-email',
            component: PageMyPreferencesChangeEmail,
            props: {
              meta: {
                title: 'label.change_email',
                section: 'label.my_preferences',
              },
            },
            children: [
              {
                path: 'verify-email',
                name: 'my-preferences-verify-email',
                component: PageVerifyEmail,
                props: route => ({
                  token: route.query.token,
                  meta: {
                    title: 'label.verify_email',
                    navigation: {
                      cancel: 'my-preferences-change-email',
                    },
                  },
                }),
              },
            ],
          },
          {
            path: 'status',
            name: 'my-preferences-settings-status',
            component: PageMyPreferencesChangeStatus,
            props: {
              meta: {
                title: 'label.deactivate_account',
                section: 'label.my_preferences',
              },
            },
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/professional/settings/router-my-preferences.js